import styled from "styled-components";

export const StatusBar = styled.button<{ended?:boolean}>`
  width: 150px;
  height: 45px;
  border-radius: 23px;
  background: ${({ended}) => ended ? '#B8BFD0' : 'linear-gradient(137deg, #2E8EFE 0%, #DD00F2 100%)'};
  font-size: ${({ended}) => ended ? 16:14}px;
  font-weight: bold;
  color: #FFF;
`